<script setup lang="ts">
import { computed } from 'vue';
import type { CalculationResult, CalculationResults } from '@/lib/calculator/result';
import { ResultCases } from '@/lib/calculator/calculator';

import ResultTablePL from '@/components/result/ResultTablePL.vue';
import ResultTablePlanet from '@/components/result/ResultTablePlanet.vue';
import type { Fleet } from '@/lib/trashsim/fleet';
import { PartyMembers } from '@/lib/trashsim/party';
import type { Settings } from '@/lib/trashsim/settings';
import Format from '@/lib/trashsim/format';
import ResultPlunder from './result/ResultPlunder.vue';
import type { Outcome } from '@/lib/newsimulator/simulator';

const props = defineProps<{
    modelValue?: CalculationResult | null
    results?: CalculationResults | null
    attacker: Fleet
    defender: Fleet
    settings: Settings
}>()
const emits = defineEmits<{
    (e: 'update:modelValue', value?: CalculationResult | null): void
}>()

const result = computed({
    get: () => props.modelValue,
    set: (value?: CalculationResult | null) => emits('update:modelValue', value)
})

const selectCase = (res: string) => {
    if (props.results !== null) {
        result.value = props.results?.cases[res]
    }
}

const outcomes: (keyof Outcome)[] = ['attackers', 'defenders', 'draw']

</script>

<template>
    <div id="results" :class="{active: result != null}">
        <div id="results-cases">
            <ul>
                <li
                    v-for="resultCase in ResultCases" :id="'results-case-'+resultCase"
                    v-bind:class="{active: results != null && result == results.cases[resultCase]}"
                    @click="selectCase(resultCase)"
                >
                    <span></span>
                </li>
            </ul>
        </div>
        <div class="results-tables">
            <!-- Result -->
            <div id="simulation-result" class="result-table">
                <table>
                    <thead>
                        <tr>
                            <th colspan=3>Result</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="outcome in outcomes">
                            <td class="fixed">{{ $t('home.result.win.'+outcome) }}</td>
                            <td v-if="result == null">/</td>
                            <td v-else>{{ Format.Outcome(results?.outcome[outcome] || 0, results) }}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th>Rounds:</th>
                            <td> {{ Format.Number(result?.rounds) }}</td>
                        </tr>
                        <tr>
                            <th>Tactical retreat:</th>
                            <td>- : -</td>
                        </tr>
                    </tfoot>
                </table>
            </div>

            <!-- P&L tables -->
            <ResultTablePL
                v-for="(party) in PartyMembers"
                :party="party"
                :profits="result?.profits[party]"
                :loses="result?.loses[party]"
            />

            <!-- Debris -->
            <ResultTablePlanet
                :debris="result?.debris"
            />

            <!-- Plunder -->
            <ResultPlunder
                :plunder="result?.plunder"
                :resources="defender.resources"
                :attacker="attacker"
                :settings="settings"
            />
            <!-- reaper data -->
            <!-- <div class="result-table result-table-debris">
                
            </div> -->
        </div>
    </div>
</template>